// Textes des états de prise (spec anti-perte phase 1, §4). Relus par Regard
// (2 passes) et validés par Thierry le 2026-09-26. Aucun composant n'écrit ces
// chaînes en dur.
// Durées : formatTrashDuration (« 45 secondes », « 1 min 28 s » sous 3 min, « 40 min », « 1 h 29 min » ; espaces insécables).
// Dates de la carte : mois en entier, comme le titre des captures.
export const FORBIDDEN_SCREEN_WORDS = [
  "fusion",
  "morceau",
  "segment",
  "serveur",
  "assemblage",
  "erreur",
  "bogue",
] as const;

export const TAKE_COPY = {
  badgePreparing: "En préparation",
  badgeProblem: "Problème signalé",
  badgeIncomplete: "Enregistrement incomplet",
  preparingTitle: (duree: string) => `Ton enregistrement de ${duree} est en sécurité.`,
  preparingBody:
    "On le prépare. Ça peut prendre quelques minutes. Tu peux quitter l'app sans rien perdre.",
  needsNetwork: "Pour finir la préparation, connecte-toi à Internet quand tu pourras.",
  problemTitle: "Ton enregistrement est en sécurité, mais on n'a pas réussi à le préparer.",
  problemBody: (duree: string) =>
    `Il dure ${duree}. L'équipe d'Écoute est prévenue. Tu n'as rien à faire.`,
  retry: "Réessayer",
  // Micro-texte d'attente du bouton « Réessayer » pendant l'appel serveur.
  retrying: "On réessaie…",
  // L'écart, jamais deux totaux à soustraire (SIG-260929-160530, 2026-09-30).
  // Trois phrases relues par Regard le 30-09 : « pendant » ne se lit pas comme
  // une heure, et le total n'est pas présenté comme la durée gardée.
  incomplete: (ecart: string, total: string) =>
    `Il manque environ ${ecart}. Tu as enregistré pendant ${total}.`,
  // Écart mineur (< 30 s) : la rassurance passe par les mots, pas par le gris.
  incompleteMinor: (ecart: string, total: string) =>
    `Il manque environ ${ecart} dans ton enregistrement de ${total}. Tout le reste est là.`,
  // Moins de 10 % gardés : jamais « 1 h 29 min … de 1 h 29 min ». Sans durée
  // gardée mesurable, pas de « on a seulement » (jamais une seconde inventée).
  incompleteMostlyLost: (total: string, capte: string | null) =>
    capte
      ? `Il manque presque tout. Tu as enregistré pendant ${total}, mais on a seulement ${capte}.`
      : `Il manque presque tout. Tu as enregistré pendant ${total}.`,
  analyzeAnyway: "Analyser quand même",
  toFinishTitle: (date: string, heure: string, duree: string) =>
    `On a retrouvé sur ton téléphone un enregistrement du ${date} à ${heure}. Il dure ${duree}.`,
  finish: "Sauvegarder l'enregistrement",
  ignore: "Mettre à la corbeille",
  // En-tête de la carte d'accueil (décision du contrôleur A9 : jamais
  // « Enregistrement à terminer »).
  foundHeader: "Enregistrement retrouvé",
  // ── Ajouts A9 : sélecteur de projet tutoyé (repris d'`OrphanRecordingCard`),
  // échec d'un geste de la carte.
  chooseProject:
    "Choisis le projet de cet enregistrement, puis touche « Sauvegarder l'enregistrement ».",
  projectLabel: "Projet",
  projectPlaceholder: "Choisir un projet…",
  projectSelectLabel: "Projet de l'enregistrement",
  noProjectAvailable:
    "Tu n'as accès à aucun projet pour l'instant. L'enregistrement reste sur ton téléphone. Écris à l'équipe d'Écoute.",
  actionFailed:
    "Ça n'a pas marché. L'enregistrement est toujours sur ton téléphone. Réessaie. Si ça recommence, écris à l'équipe d'Écoute.",
} as const;
